module.exports = __webpack_public_path__ + "img/googlereviewsp4.9390e1df.png";